import Element from './Element';

export default class FriendItem extends Element {
    public create(params: any): void {
        super.create({
            type: 'group',
            layout: {
                anchors: [0, 0, 1, 0],
                offsets: [0, 0, 0, 0],
                pivot: [0.5, 0],
                constrains: {
                    heightMin: 104,
                    heightMax: 104,
                    widthMin: 500,
                    widthMax: 500,
                },
            },
            components: [
                {
                    type: 'nineslice',
                    data: {
                        cacheKey: 'rounded_rectangle1_9_slice',
                        offset: [15, 15, 15, 15],
                    },
                },
            ],
            children: [
                {
                    type: 'group',
                    name: 'avatar',
                    layout: {
                        anchors: [0.18, 0.5, 0.18, 0.5],
                        pivot: [0.5, 0.5],
                        offsets: [0, 0, 0, 0],
                        constrains: {
                            heightMin: 78,
                            heightMax: 78,
                            widthMin: 78,
                            widthMax: 78,
                        },
                    },
                    components: [
                        {
                            type: 'image',
                            data: {
                                cacheKey: 'no_avatar',
                            },
                        },
                    ],
                },
                {
                    type: 'group',
                    name: 'crown',
                    layout: {
                        anchors: [0.18, 0.5, 0.18, 0.5],
                        pivot: [0.5, 1],
                        offsets: [0, 36, 0, 36],
                    },
                    components: [
                        {
                            type: 'image',
                            data: {
                                cacheKey: 'crown',
                            },
                        },
                    ],
                },
                {
                    type: 'text',
                    name: 'rank',
                    layout: {
                        anchors: [0.05, 0.5, 0.05, 0.5],
                        pivot: [0.5, 0.5],
                        offsets: [0, 0, 0, 0],
                    },
                    components: [
                        {
                            type: 'text',
                            data: {
                                textUnlocalized: 1,
                                style: {
                                    font: 'RussoOne',
                                    fill: '#006EB6',
                                    fontSize: '32px',
                                },
                                align: 'center',
                            },
                        },
                    ],
                },
                {
                    type: 'text',
                    name: 'name',
                    layout: {
                        anchors: [0.3, 0.5, 0.3, 0.5],
                        pivot: [0, 0.5],
                        offsets: [0, 0, 0, 0],
                    },
                    components: [
                        {
                            type: 'text',
                            data: {
                                textUnlocalized: params.playerName,
                                style: {
                                    font: 'RussoOne',
                                    fill: '#531E0F',
                                    fontSize: '30px',
                                },
                                align: 'left',
                                bounds: [120, 100],
                                wordWrap: true,
                                wordWrapWidth: 120
                            },
                        },
                    ],
                },
                {
                    type: 'image',
                    name: 'star',
                    layout: {
                        anchors: [0.94, 0.5, 0.94, 0.5],
                        pivot: [0.5, 0.5],
                        offsets: [0, 0, 0, 0],
                        scale: [0.65, 0.65],
                    },
                    components: [
                        {
                            type: 'image',
                            data: {
                                cacheKey: 'star_bright',
                            },
                        },
                    ],
                },
                {
                    type: 'text',
                    name: 'score',
                    layout: {
                        anchors: [0.89, 0.5, 0.89, 0.5],
                        pivot: [1, 0.5],
                        offsets: [0, 0, 0, 0],
                    },
                    components: [
                        {
                            type: 'text',
                            data: {
                                textUnlocalized: 999,
                                style: {
                                    font: 'RussoOne',
                                    fill: '#531E0F',
                                    fontSize: '24px',
                                },
                                align: 'right',
                            },
                        },
                    ],
                },
                {
                    type: 'group',
                    name: 'btnGift',
                    layout: {
                        anchors: [0.66, 0.55, 0.66, 0.55],
                        pivot: [0.5, 0.5],
                        offsets: [0, 0, 0, 0],
                    },
                    components: [
                        {
                            type: 'image',
                            data: {
                                cacheKey: 'Gift_button',
                            },
                        },
                        {
                            type: 'input',
                            data: {
                                enabled: true,
                            },
                        },
                    ],
                },
                {
                    type: 'text',
                    name: 'giftTimer',
                    layout: {
                        anchors: [0.66, 0.6, 0.66, 0.6],
                        pivot: [0.5, 0.5],
                        offsets: [0, 0, 0, 0],
                    },
                    components: [
                        {
                            type: 'text',
                            data: {
                                textUnlocalized: '00:00:00',
                                style: {
                                    font: 'RussoOne',
                                    fill: '#006EB6',
                                    fontSize: '20px',
                                    stroke: "#fff",
                                    strokeThickness: 3,
                                },
                                align: 'center',
                            },
                        },
                        {
                            type: 'visibility',
                            data: {
                                hidden: true
                            }
                        }
                    ],
                }
            ],
            ...params,
        });
    }
}
